import { render } from "./full_dermatology_head.vue?vue&type=template&id=30f9e4ec&scoped=true"
import script from "./full_dermatology_head.vue?vue&type=script&lang=js"
export * from "./full_dermatology_head.vue?vue&type=script&lang=js"

import "./full_dermatology_head.vue?vue&type=style&index=0&id=30f9e4ec&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f9e4ec"]])

export default __exports__